import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Modal, Button, Form, Input, Select, Radio, message, Row, Col, } from "antd";
import { Formik, Field, Form as FormikForm } from "formik";
import * as Yup from "yup";
import useFetchApiData from "../helper/useFetchApiData";
import { useNavigate } from "react-router-dom";
 

const Checkout = () => {
  const [selectedPayment, setSelectedPayment] = useState("payment1");
  const [cartItems, setCartItems] = useState([]);
  const [couponCode, setCouponCode] = useState("");
  const [loading, setLoading] = useState(true);
  const [discountAmount, setDiscountAmount] = useState(0);
  const addresses = useFetchApiData("/customer/address/list");
  const userData = useFetchApiData("/customer/info");
  const navigate=useNavigate()

  const subtotal = cartItems.reduce((acc, item) => acc + item.subtotal, 0);
  const [grandTotal, setGrandTotal] = useState(subtotal);
  const calculateGrandTotal = (items) => {
    return items.reduce((total, item) => total + item.subtotal, 0);
  };

  const submitCoupon = async (code) => {
    try {
      const domain = process.env.REACT_APP_BACKEND_URI;
      const url = `${domain}/coupon/apply`;
      const accessToken = localStorage.getItem("accessToken");

      const response = await axios.get(url, {
        params: { code },
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      const coupon = response.data;
      let discountAmount = 0;

      if (subtotal >= coupon.min_purchase) {
        if (coupon.discount_type === "percent") {
          discountAmount = (subtotal * coupon.discount) / 100;
          discountAmount = Math.min(discountAmount, coupon.max_discount);
        } else if (coupon.discount_type === "fixed") {
          discountAmount = Math.min(coupon.discount, coupon.max_discount);
        }

        setDiscountAmount(discountAmount);
        setGrandTotal(subtotal - discountAmount);
      } else {
        console.warn("Minimum purchase requirement not met for this coupon.");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleCodeSubmit = (e) => {
    console.warn("Handle Code Triggered");
    e.preventDefault();
    submitCoupon(couponCode);
  };

  useEffect(() => {
    const fetchCartData = async () => {
      try {
        const cart = JSON.parse(localStorage.getItem("cart") || "[]");
        const cartData = await Promise.all(
          cart.map(async (item) => {
            try {
              const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URI}/products/details/${item.id}`
              );
              const product = response.data.product;
              return {
                id: product.id,
                name: product.name,
                image: product.image_fullpath[0],
                price: product.price,
                quantity: item.qty,
                variation: item.variation,
                subtotal: product.price * item.qty,
              };
            } catch (productError) {
              console.error(`Error fetching product ${item.id}:`, productError);
              return null;
            }
          })
        );

        const validCartData = cartData.filter((item) => item !== null);

        setCartItems(validCartData);
        setGrandTotal(calculateGrandTotal(validCartData));
        setLoading(false);
      } catch (error) {
        console.error("Error fetching cart data:", error);
        setLoading(false);
        message.error("Failed to load cart items");
      }
    };

    fetchCartData();
  }, []);


  const validationSchema = Yup.object({
    order_note: Yup.string().nullable(),
    delivery_address_id: Yup.string().required("Delivery address is required"),
    payment_method: Yup.string()
      .oneOf(["cash_on_delivery","bank_transfer"], "Invalid payment method")
      .required("Payment method is required"),
    coupon_code: Yup.string().nullable(),
    cart: Yup.array()
      .min(1, "Cart must contain at least one item")
      .required("Cart cannot be empty")
      .of(
        Yup.object({
          product_id: Yup.number().required("Product ID is required"),
          quantity: Yup.number()
            .min(1, "Quantity must be at least 1")
            .required("Quantity is required"),
           
        })
      ),
  });

  const handleSubmit = async (values) => {
    try {
      message.loading({ content: "Placing order...", key: "order" });
      const domain = process.env.REACT_APP_BACKEND_URI;
      const accessToken = localStorage.getItem("accessToken");
      
      // Prepare the order data
      const orderData = {
        ...values,
        delivery_address_id:parseInt(values. delivery_address_id),
        cart: cartItems.map(item => ({
          product_id: item.id,
          quantity: item.quantity,
          variations: item.variation || []
        }))
      };
      console.log("Final Api",orderData)

      await axios.post(domain+"/customer/order/place", orderData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        }
      });

      message.success({ content: "Order placed successfully!", key: "order" });
      localStorage.removeItem("cart"); 
      navigate("/orders"); 
      
    } catch (error) {
      console.error("Order error:", error);
      message.error({
        content: error.response?.data?.message || "Failed to place order",
        key: "order"
      });
    }
  };
  

  console.warn(cartItems);
  return (
    <section className="checkout py-80">
      <div className="container container-lg">
        <Formik
          enableReinitialize
          initialValues={{
            order_amount: subtotal - discountAmount,
            delivery_address_id: "",
            order_note: "",
            coupon_code: "",
            coupon_discount_amount:0,
            order_type: "delivery",
            coupon_discount_title: "sa",
            free_delivery_type: "", 
            branch_id: 1,
            payment_method: selectedPayment,
            cart: cartItems.map((item) => ({
              product_id: item.id,
              quantity: item.quantity,
            })),
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, errors, touched, handleSubmit }) => (
            <FormikForm>
              {console.error(errors)}
              {console.log(values)}

              <div className="row">
                <div className="col-xl-6 col-lg-6">
                  <div className="row gy-3">
                    <div className="col-sm-6 col-xs-6">
                      <input
                        type="text"
                        className="common-input border-gray-100"
                        placeholder="First Name"
                        disabled
                        value={userData.f_name}
                      />
                    </div>
                    <div className="col-sm-6 col-xs-6">
                      <input
                        type="text"
                        className="common-input border-gray-100"
                        placeholder="Last Name"
                        disabled
                        value={userData.l_name}
                      />
                    </div>

                    <div className="col-12">
                      <input
                        type="number"
                        className="common-input border-gray-100"
                        placeholder="Phone"
                        disabled
                        value={userData.phone}
                      />
                    </div>
                    <div className="col-12">
                      <input
                        type="email"
                        className="common-input border-gray-100"
                        placeholder="Email Address"
                        disabled
                        value={userData.email}
                      />
                    </div>
                    <div className="col-12">
                      <label>Delivery Address</label>
                      <Field
                        as="select"
                        className="common-input border-gray-100"
                        name="delivery_address_id"
                      >
                        <option value="" disabled>
                          Select address
                        </option>
                        {addresses.map((address, index) => (
                          <option key={index} value={address.id}>
                            {address.address}
                          </option>
                        ))}
                      </Field>

                      {errors.delivery_address_id &&
                        touched.delivery_address_id && (
                          <div className="text-red-500">
                            {errors.delivery_address_id}
                          </div>
                        )}
                    </div>

                    <div className="col-12">
                      <div className="my-40">
                        <h6 className="text-lg mb-24">Order Note</h6>
                        <Field
                          as="textarea"
                          className="common-input border-gray-100"
                          name="order_note"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6">
                  <div className="checkout-sidebar">
                    <div className="bg-color-three rounded-8 p-24 text-center">
                      <span className="text-gray-900 text-xl fw-semibold">
                        Your Orders
                      </span>
                    </div>
                    <div className="border border-gray-100 rounded-8 px-24 py-40 mt-24">
                      <div className="mb-32 pb-32 border-bottom border-gray-100 flex-between gap-8">
                        <span className="text-gray-900 fw-medium text-xl font-heading-two">
                          Product
                        </span>
                        <span className="text-gray-900 fw-medium text-xl font-heading-two">
                          Total
                        </span>
                      </div>
                      {cartItems.map((item, index) => (
                        <div key={index} className="flex-between gap-24 mb-32">
                          <div className="flex-align gap-12">
                            <span className="text-gray-900 fw-normal text-md font-heading-two w-144">
                              {item.name}
                            </span>
                            <span className="text-gray-900 fw-normal text-md font-heading-two">
                              <i className="ph-bold ph-x" />
                            </span>
                            <span className="text-gray-900 fw-semibold text-md font-heading-two">
                              {item.quantity}
                            </span>
                          </div>
                          <span className="text-gray-900 fw-bold text-md font-heading-two">
                            Rs.{item.subtotal.toFixed(2)}
                          </span>
                        </div>
                      ))}
                      <div className="border-top border-gray-100 pt-30 mt-30">
                        <div className="mb-32 flex-between gap-8">
                          <span className="text-gray-900 font-heading-two text-xl fw-semibold">
                            Subtotal
                          </span>
                          <span className="text-gray-900 font-heading-two text-md fw-bold">
                            Rs. {subtotal}
                          </span>
                        </div>

                        {discountAmount > 0 && (
                          <div className="mb-32 flex-between gap-8">
                            <span className="font-heading-two text-xl fw-semibold text-danger">
                              Discount
                            </span>
                            <span className="text-danger font-heading-two text-md fw-bold">
                              - Rs. {discountAmount}
                            </span>
                          </div>
                        )}

                        <div className="mb-0 flex-between gap-8">
                          <span className="text-gray-900 font-heading-two text-xl fw-semibold">
                            Grand Total
                          </span>
                          <span className="text-gray-900 font-heading-two text-md fw-bold">
                            Rs. {subtotal - discountAmount}
                          </span>
                        </div>
                        {discountAmount ==0 && (
                        <div className="mb-0 flex-between gap-8">
                          <span>
                            Have a coupon?{" "}
                            <Link
                              to="/cart"
                              className="fw-semibold text-gray-900 hover-text-decoration-underline hover-text-main-600"
                            >
                              Click here to enter your code
                            </Link>
                          </span>

                          <span className="d-flex align-items-center gap-2">
                            <Field
                              name="coupon_code"
                              type="text"
                              className="form-control"
                              placeholder="Enter your code"
                              required
                            />
                            <Button
                              type="submit"
                              className="btn btn-danger"
                              onClick={() => submitCoupon(values.coupon_code)}
                            >
                              Redeem
                            </Button>
                          </span>
                        </div>
                        )}
                      </div>
                      
                    </div>
                    <div className="mt-32">
                      <label>Payment Method</label>
                      <div className="mt-32">
                        {[
                          { id: "direct_bank_transfer", label: "Direct Bank Transfer" },
                          { id: "cash_on_delivery", label: "Cash on Delivery" },
                        ].map(({ id, label }) => (
                          <div className="payment-item" key={id}>
                            <div className="form-check common-check common-radio py-16 mb-0">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="payment_method"
                                id={id}
                                checked={values.payment_method === id}
                                onChange={() =>
                                  setFieldValue("payment_method", id)
                                }
                              />
                              <label
                                className="form-check-label fw-semibold text-neutral-600"
                                htmlFor={id}
                              >
                                {label}
                              </label>
                            </div>
                            {values.payment_method === id && (
                              <div className="payment-item__content px-16 py-24 rounded-8 bg-main-50 position-relative d-block">
                                <p className="text-gray-800">
                                  Make your payment directly into our bank
                                  account. Please use your Order ID as the
                                  payment reference.
                                </p>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="checkout-sidebar-action mt-40">
                      <Button
                        type="primary"
                        htmlType="submit"
                        onClick={handleSubmit}
                        block
                      >
                        Place Order
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </FormikForm>
          )}
        </Formik>
      </div>
    </section>
  );
};

export default Checkout;
